/**
 * Logger utility for conditional console logging
 * Only logs in development mode to keep production clean and secure
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /**
   * Log information - only in development
   */
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },

  /**
   * Log warnings - only in development
   */
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },

  /**
   * Log errors - always log errors (even in production)
   */
  error: (...args: any[]) => {
    console.error(...args);
  },

  /**
   * Log debug info - only in development
   */
  debug: (...args: any[]) => {
    if (isDev) console.debug(...args);
  },

  /**
   * NEVER log sensitive data like tokens, passwords, etc.
   * This helper redacts sensitive strings for safe logging
   */
  redact: (value: string, showChars: number = 4): string => {
    if (!value || value.length <= showChars) return '***';
    return `${value.substring(0, showChars)}...`;
  },
};

// Export convenience methods
export const { log, warn, error, debug, redact } = logger;
